<template>
    <div id="aboutPageRoot">
        <div>
            <h2 id="missionStatement" v-html="missionStatement"></h2>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            document.title = "About - OT";
        },
        computed: {
            missionStatement() {
                return this.$store.state.missionStatement;
            },
            slogan() {
                return this.$store.state.slogan;
            }
        }
    };
</script>

<style lang="scss" src="../styles/about.scss" scoped/>
